
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useUserRoles } from '@/hooks/use-user-roles';
import { UserManagement } from '@/components/admin/UserManagement';
import { ProhibitedWordsManager } from '@/components/admin/ProhibitedWordsManager';
import { SoftBlockWordsManager } from '@/components/admin/SoftBlockWordsManager';
import SlowModeSettings from '@/components/admin/SlowModeSettings';
import ModerationManagement from '@/components/admin/ModerationManagement';
import FlaggedRelicsManager from '@/components/admin/FlaggedRelicsManager';
import RelicStorageMigrator from '@/components/admin/RelicStorageMigrator';
import DropsAdminManager from '@/components/admin/DropsAdminManager';
import ProfileEmbeddingsManager from '@/components/admin/ProfileEmbeddingsManager';
import BackfillRunner from '@/components/BackfillRunner';
import { VerificationManager } from '@/components/admin/VerificationManager';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const AdminDashboard = () => {
  const { user } = useAuth();
  const { isAdmin, loading } = useUserRoles();

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="text-center">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Access Denied</h1>
          <p>You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8 max-w-6xl">
      <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>
      
      <Tabs defaultValue="verification" className="w-full">
        <TabsList className="grid w-full grid-cols-11">
          <TabsTrigger value="verification">Verification</TabsTrigger>
          <TabsTrigger value="users">Users</TabsTrigger>
          <TabsTrigger value="moderation">Moderation</TabsTrigger>
          <TabsTrigger value="drops">Drops</TabsTrigger>
          <TabsTrigger value="flagged-relics">Flagged Relics</TabsTrigger>
          <TabsTrigger value="storage-migrator">Storage Migration</TabsTrigger>
          <TabsTrigger value="backfill">Content Backfill</TabsTrigger>
          <TabsTrigger value="embeddings">Embeddings</TabsTrigger>
          <TabsTrigger value="prohibited">Prohibited Words</TabsTrigger>
          <TabsTrigger value="soft-block">Soft Block Words</TabsTrigger>
          <TabsTrigger value="settings">Settings</TabsTrigger>
        </TabsList>
        
        <TabsContent value="verification" className="mt-6">
          <VerificationManager />
        </TabsContent>
        
        <TabsContent value="users" className="mt-6">
          <UserManagement />
        </TabsContent>
        
        <TabsContent value="moderation" className="mt-6">
          <ModerationManagement />
        </TabsContent>
        
        <TabsContent value="drops" className="mt-6">
          <DropsAdminManager />
        </TabsContent>
        
        <TabsContent value="flagged-relics" className="mt-6">
          <FlaggedRelicsManager />
        </TabsContent>
        
        <TabsContent value="storage-migrator" className="mt-6">
          <RelicStorageMigrator />
        </TabsContent>
        
        <TabsContent value="backfill" className="mt-6">
          <BackfillRunner />
        </TabsContent>
        
        <TabsContent value="embeddings" className="mt-6">
          <ProfileEmbeddingsManager />
        </TabsContent>
        
        <TabsContent value="prohibited" className="mt-6">
          <ProhibitedWordsManager />
        </TabsContent>
        
        <TabsContent value="soft-block" className="mt-6">
          <SoftBlockWordsManager />
        </TabsContent>
        
        <TabsContent value="settings" className="mt-6">
          <SlowModeSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminDashboard;
